const routes = [{
  path: '/auditArticle',
  component: () => import('@/views/audit/article'),
  name: 'audit-article',
  meta: {
    title: '文章审核'
  }
}, {
  path: '/articleReview',
  component: () => import('@/views/audit/articleReview'),
  name: 'audit-articleReview',
  meta: {
    title: '文章详情'
  }
}, {
  path: '/InstitutionalReview',
  component: () => import('@/views/audit/InstitutionalReview'),
  name: 'audit-InstitutionalReview',
  meta: {
    title: '机构信息审核'
  }
}, {
  path: '/amendMsg',
  component: () => import('@/views/audit/amendMsg'),
  name: 'audit-amendMsg',
  meta: {
    title: '机构信息修改详情'
  }
}, {
  path: '/certification',
  component: () => import('@/views/audit/certification'),
  name: 'audit-certification',
  meta: {
    title: '机构认证修改详情'
  }
}, {
  path: '/AccreditedInstitution',
  component: () => import('@/views/audit/AccreditedInstitution'),
  name: 'audit-AccreditedInstitution',
  meta: {
    title: '机构认证修改详情'
  }
}, {
  path: '/picture',
  component: () => import('@/views/audit/picture'),
  name: 'audit-picture',
  meta: {
    title: '机构认证修改详情'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/audit.js